import { render, staticRenderFns } from "./createCompetencyGroup.vue?vue&type=template&id=1e6b48f9&"
import script from "./createCompetencyGroup.vue?vue&type=script&lang=js&"
export * from "./createCompetencyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports